import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  withStyles,
  Grid,
  Box,
  Typography,
  IconButton,
} from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import CreateFlowLibraryForm from "./CreateFlowLibraryForm";

class CreateFlowLibraryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;
    const flow = this.props.location?.state?.flow || {};

    const flowLibraryCategories =
      this.props.location?.state?.flowLibraryCategories || [];

    return (
      <div className={classes.root}>
        {/* Page name & description container */}
        <Grid
          container
          justify="center"
          alignItems="center"
          className={`${classes.pageTitleContainer} ${classes.fullWidth}`}
        >
          <Grid item>
            <Box pl={{ xs: 2, md: 2 }}>
              <IconButton component={Link} to={"/flow-library"}>
                <ArrowBack />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs>
            <Typography variant="h3">New Flow Library Message</Typography>
          </Grid>
        </Grid>
        <Box my={3} />
        {/* Layout */}
        <Grid container justify="center">
          <Grid item xs={12} md={11} lg={10}>
            <CreateFlowLibraryForm
              flow={flow}
              flowLibraryCategories={flowLibraryCategories}
            />
          </Grid>
        </Grid>
        <Box my={15} />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
    background: "rgb(249,249,249)",
    boxSizing: "border-box",
    overflowX: "hidden",
    position: "relative",
  },
  pageTitleContainer: {
    position: "sticky",
    zIndex: 100,
    top: 0,
    height: 60,
    boxSizing: "border-box",
  },
  fullWidth: {
    width: "100%",
    background: "white",
  },
  container: {
    background: "white",
    borderRadius: "8px",
  },
});

export default withStyles(styles)(CreateFlowLibraryPage);
